export enum StorySortBy {
  byCommentCount = 1,
  byLikeCount = 2,
  byDateUpdated = 3,
  byDateCreated = 4,
  byRandom = 5,
}
